import React from 'react'

import type { MyTicketDetailModel } from '@/components/myTicket/model'
import { TicketDetailModel } from '@/components/purchase/components/parkinglot/model'
import AirportComplete from '@/components/purchase/components/shared/purchaseComplete/components/airport/view'
import ExtendParkinglotComplete from '@/components/purchase/components/shared/purchaseComplete/components/extendParkinglot/view'
import ParkinglotPurchaseComplete from '@/components/purchase/components/shared/purchaseComplete/components/parkinglot/view'
import SharedPurchaseComplete from '@/components/purchase/components/shared/purchaseComplete/components/sharedParkinglot/view'

import type { AirportTicketDetail } from '@/api/server/airport/dto/airportDto'
import type { SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'

const PurchaseCompleteView = ({
  isComplete,
  data,
  time,
  carNum,
  ticketSeq,
  onClick
}: {
  isComplete: boolean
  data: TicketDetailModel | SharedParkinglotDetail | MyTicketDetailModel | AirportTicketDetail
  time: string | number
  carNum: string
  ticketSeq?: number
  onClick: () => void
}) => {
  if ('type' in data) {
    return (
      <SharedPurchaseComplete
        isComplete={isComplete}
        data={data}
        time={Number(time)}
        carNum={carNum}
        onClick={onClick}
      />
    )
  }
  if ('ticket' in data) {
    return (
      <ExtendParkinglotComplete
        isComplete={isComplete}
        data={data}
        time={String(time)}
        carNum={carNum}
        onClick={onClick}
      />
    )
  }
  if ('labels' in data) {
    return (
      <AirportComplete
        data={data}
        isComplete={isComplete}
        time={String(time)}
        carNum={carNum}
        onClick={onClick}
        ticketSeq={ticketSeq}
      />
    )
  }
  return (
    <ParkinglotPurchaseComplete
      isComplete={isComplete}
      data={data}
      time={String(time)}
      carNum={carNum}
      onClick={onClick}
    />
  )
}

export default PurchaseCompleteView
